<template>
  <el-form ref="form" :model="data" label-width="100px">
    <el-form-item :label="$t('管理员名称')" width="100px">
      <el-select v-model="adminId" placeholder="请选择" filterable>
        <el-option
          v-for="item in user"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
    </el-form-item>
    <el-form-item :label="$t('广告主名称')">
      <el-select v-model="advertId" placeholder="请选择" filterable>
        <el-option
          v-for="item in advertiser"
          :key="item.id"
          :label="item.account_name"
          :value="item.id"
        />
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="submit">{{ $t('提交') }}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: 'AdminAdvertAdd',
  props: {
    advertiser: {
      type: Array,
      default() {
        return []
      }
    },
    user: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      id: '',
      data: {
        adminName: '',
        advertName: ''
      },
      // 存放选择的结果
      advertId: '',
      adminId: ''
    }
  },
  methods: {
    submit() {
      this.$emit('submit', this.adminId, this.advertId)
    }
  }
}
</script>

<style scoped lang="less">
  /deep/ .el-input__inner {
    width: 300px;
  }
</style>
